import React, { useContext } from 'react'
import GeneralContext from '../../../context/GeneralContext/GeneralContext'


export default function Iframe({ url }) {

    const {
        mobile_mode
    } = useContext(GeneralContext)

    return (
        <div className={`${!mobile_mode ? 'p-5 mb-3' : 'mb-6'}`}>
            <iframe
                width="100%"
                height={`${mobile_mode ? '300px' : '600px'}`}
                src={url}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                className='rounded-3xl' 
                loading='lazy'
            />
        </div>
    )
}
